// extracted by mini-css-extract-plugin
export var acitonButtons = "_g1-0";
export var additionalIcon = "_g1-f";
export var block = "_g1-1";
export var blockContent = "_g1-7";
export var blockDescription = "_g1-8";
export var blockIcon = "_g1-9";
export var blockTitle = "_g1-6";
export var border = "_g1-a";
export var center = "_g1-l";
export var edge = "_g1-b";
export var edgeLabel = "_g1-c";
export var edgePath = "_g1-d";
export var error = "_g1-e";
export var flowchart = "_g1-g";
export var flowchartContent = "_g1-h";
export var highlighted = "_g1-3";
export var hover = "_g1-4";
export var icon = "_g1-i";
export var left = "_g1-m";
export var navButton = "_g1-j";
export var navButtons = "_g1-k";
export var right = "_g1-n";
export var selected = "_g1-2";
export var small = "_g1-5";